import { AnimatedSprite } from './AnimatedSprite';

export class Obstacle {
  constructor({ x, y, width, height, speed, type, sprite }) {
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
    this.speed = speed;
    this.type = type;
    this.sprite = sprite;
  }

  update() {
    // Simple frame-based movement (works fine at 60 FPS)
    this.x -= this.speed;
    
    if (this.sprite) {
      this.sprite.update();
    }
  }

  draw(ctx) {
    // Always draw fallback (emojis) for now - sprites can be added later
    const emojis = {
      WALL: '🧱',
      TREE: '🌳',
      CLOUD: '☁️',
      LIGHTNING: '⚡'
    };
    
    // Save context state
    ctx.save();
    
    // Draw emoji only (no rectangle background) - make it bigger
    // Use larger font size based on obstacle size
    const fontSize = Math.max(this.width, this.height) * 0.8;
    ctx.font = `${fontSize}px Arial`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    
    // Draw emoji with a subtle shadow for visibility
    ctx.shadowColor = 'rgba(0, 0, 0, 0.3)';
    ctx.shadowBlur = 4;
    ctx.shadowOffsetX = 2;
    ctx.shadowOffsetY = 2;
    
    ctx.fillText(
      emojis[this.type] || '🧱',
      this.x + this.width / 2,
      this.y + this.height / 2
    );
    
    // Restore context state
    ctx.restore();
  }
}

